import Component from "gia/Component";
import { AddToCart, UpdateCart } from "../components/CartEvents.js";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.form = this.DOM.view.querySelector('form[action$="/cart/add"]');
    //
    this.events();
  }

  events() {
    this.ref.add[0].addEventListener("click", () => {
      const data = new FormData(this.DOM.form);
      AddToCart(data, false);
    });
    this.ref.remove[0].addEventListener("click", () => {
      let getQty = this.DOM.view.getAttribute("data-qty");
      let newQty = getQty - 1;

      const data = {
        id: new FormData(this.DOM.form).get("key_cart"),
        quantity: newQty,
      };
      UpdateCart(data);
    });
  }

  unmount() {}
}
